import script from "./photos.vue?vue&type=script&setup=true&lang=ts"
export * from "./photos.vue?vue&type=script&setup=true&lang=ts"

import "./photos.vue?vue&type=style&index=0&id=5fc52d62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fc52d62"]])

export default __exports__